import React from 'react';
import PropTypes from 'prop-types';

import { PerksSection, PerksHeading, PerksList, PerksTitle, PerksDescription } from "./styles";

const PlanPerks = ({ passType, perks }) => (
  <PerksSection>
    <PerksHeading passType={passType}>Special Perks</PerksHeading>
    <PerksList>
      {perks.map(perk => (
        <li key={perk.title}>
          <PerksTitle>{perk.title}</PerksTitle>
          <PerksDescription>{perk.description}</PerksDescription>
        </li>
        ))}
    </PerksList>
  </PerksSection>
);

PlanPerks.propTypes = {
  passType: PropTypes.number,
  perks: PropTypes.instanceOf(Array),
};

export default PlanPerks;
